/**
 * Emoji glyph per SKU category — used as a lightweight "icon" on the Home
 * Featured list and catalog cards (the SKU model has no real thumbnail image yet).
 * Keep the keys aligned with the backend SkuDefinition.category values.
 */
const CATEGORY_GLYPH: Record<string, string> = {
  AVATAR: '✦',
  COMPAT: '❤️',
  COUPLE: '💞',
  MOON_PHASE: '🌙',
  ASTRODUEL: '⚔️',
  GIFTING: '🎁',
  PAST_LIVES: '🕯️',
  FUTURE_CHILDREN: '👶',
  CUSTOM_LETTER: '✉️',
  COSMIC_CALENDAR: '🗓️',
  DAILY_ADVICE: '☀️',
};

/** Returns the category's glyph, or a celestial fallback for unknown categories. */
export function categoryGlyph(category: string | undefined | null): string {
  return (category && CATEGORY_GLYPH[category]) || '✦';
}

/**
 * Ordered prefix rules — first match wins.
 * Maps SKU code prefixes (or exact codes) to an emoji glyph.
 * Covers all known SKU codes; falls back to ✦ for unknown codes.
 */
const SKU_PREFIX_RULES: Array<[string, string]> = [
  ['compat_check', '❤️'],
  ['gifting_crush', '🎁'],
  ['couple_', '💞'],
  ['avatar_', '✦'],
  ['moon_phase', '🌙'],
  ['past_lives', '🕯️'],
  ['future_children', '👶'],
  ['custom_letter', '✉️'],
  ['cosmic_calendar', '🗓️'],
  ['daily_advice', '☀️'],
  ['lucky_', '🍀'],
  ['when_', '⏳'],
  ['horary_', '🔮'],
  ['check_for_me_', '⚖️'],
  ['brief_topic', '📖'],
];

/**
 * Returns a per-SKU emoji glyph by matching skuCode against known prefixes/codes.
 * Falls back to ✦ for unknown SKU codes.
 */
export function skuGlyph(skuCode: string): string {
  for (const [prefix, glyph] of SKU_PREFIX_RULES) {
    if (skuCode === prefix || skuCode.startsWith(prefix)) {
      return glyph;
    }
  }
  return '✦';
}
